class ChargebackMassRepresentmentManager {
  static transactionAdapter (transaction) {
    const {
      chargeback: { reasonDescription },
      transactionalData: { amount },
      status: { label, code },
      createdAt,
      transactionId
    } = transaction

    return {
      id: transactionId,
      createdAt,
      amount,
      reason: reasonDescription,
      statusLabel: label,
      statusCode: code
    }
  }

  static getTransactionItem (fileName, transactions) {
    const fileNameWithoutExtension = fileName.split('.')[0]

    return transactions?.find(
      transaction =>
        transaction.transactionId.toString() === fileNameWithoutExtension
    )
  }
}

export default ChargebackMassRepresentmentManager
